import { getDerivativePackageListP, getPackageListP } from 'create-api';
import * as types from '../mutation-types';

// initial state
const state = {
    packageList: [],
    selectedPackageId: 0,
    packageBuyCount: 1,
    isLogin: false
};

const getters = {
    groupPackageList: state => {
        return state.packageList.filter(item => item.groupInfo)
    },
    multiPackage: state => state.packageList.length > 1,
    groupStartPrice: (state, getters) => {
        return getters.groupPackageList.reduce((result, item) => Math.min(result, item.groupInfo.newProductPrice), Infinity)
    }
}

// actions
const actions = {
    getPackageList ({ commit }, { prdTmpId, productId, cookies, userAgent }) {
        if (prdTmpId === 3) {
            return getDerivativePackageListP({
                productId,
                terminal: 'm'
            }, cookies, userAgent).then(data => {
                if (data && data.packageList) {
                    commit(types.RECEIVE_PACKAGE_LIST, {
                        packageList: data.packageList,
                        isLogin: data.isLogin
                    });
                    return new Promise(function (resolve, reject) {
                        resolve(data);
                    });
                }
            }).catch(err => {
                console.error(err);
            });
        } else {
            return getPackageListP({
                productId,
                terminal: 'm'
            }, cookies, userAgent).then(data => {
                if (data && data.packageList) {
                    commit(types.RECEIVE_PACKAGE_LIST, {
                        packageList: data.packageList.map(item => {
                            return Object.assign(item, {
                                adultPrice: item.priceCalendarList[0].adultPrice,
                                adultStock: item.adultTotalStock
                            })
                        }),
                        isLogin: data.isLogin
                    });
                    return new Promise(function (resolve, reject) {
                        resolve(data);
                    });
                }
            }).catch(err => {
                console.error(err);
            });
        }
    },
    selectPackage ({ commit }, { packageId }) {
        commit(types.SELECT_PACKAGE, { packageId });
    },
    changePackageBuyCount ({ commit }, { count }) {
        commit(types.CHANGE_PACKAGE_BUY_COUNT, { count });
    }
};

// mutations
const mutations = {
    [types.RECEIVE_PACKAGE_LIST] (state, payload) {
        state.isLogin = payload.isLogin;
        if (payload.packageList) {
            state.packageList = payload.packageList;
        }
    },
    [types.SELECT_PACKAGE] (state, payload) {
        if (payload.packageId) {
            state.selectedPackageId = payload.packageId;
        }
    },
    [types.CHANGE_PACKAGE_BUY_COUNT] (state, payload) {
        if (payload.count) {
            state.packageBuyCount = payload.count;
        }
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};



// WEBPACK FOOTER //
// libs/store/modules/derivativePackage.js